let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bNblg")).then(() => parcelRequire('c0HkI'));